import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import { Autocomplete, Box, Button, Grid, Stack, TextField, Typography } from '@mui/material';
import GlobalDatagrid from '../../components/mui/DataGrid/GlobalDatagrid';
import {
  getBatchesForAttendance,
  getBatchesList,
  getCardsData,
  getCourseAvailable,
} from '../../redux/features/batchSlice';
import { Icon } from '@iconify/react/dist/iconify.js';
import Searchbar from '../../components/Search/Searchbar';
import AssignCro from './AssignCro';
import { CRM_Batch_View_Table_Head } from '../../components/datagrid/myworkspace/cro/CrmBatchTableHead';
import SubjectAndTutors from './SubjectAndTutors';
import CardsData from './CardsData';
import CrmStartApproval from './CrmapprovalforStart';
import { useNavigate } from 'react-router-dom';
import ToolTip from '../../components/ToolTip/ToolTip';
import { render } from '@testing-library/react';

const BatchAttendance = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { loading, batchesForAttendance } = useSelector((state) => state.batch);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const navigate = useNavigate();

  const data = {
    page: pageNum,
    limit: gridSize,
    search: search || '',
  };

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getBatchesForAttendance(data));
    }
  }, [pageNum, gridSize, search]);

  const tableHead = [
    { field: 'sl_no', headerName: 'Sl No', width: 100 },
    {
      field: 'course_batch_name',
      headerName: 'Batch Name',
      width: 250,
      renderCell: (params) => {
        return (
          <ToolTip
            content={`${params.row.course_batch_serial_no} - (${params.row.course_batch_name})`}
            expand={`${params.row.course_batch_serial_no} - (${params.row.course_batch_name})`}
          />
        );
      },
    },
    { field: 'course_name', headerName: 'Course Name', width: 250,
        renderCell: (params) => {
            return (
                <ToolTip
                    expand={params.row.course_name}
                    content={params.row.course_name}
                />
            );
     },
    },
    { field: 'cro_name', headerName: 'CRO Name', width: 200 },
    { field: 'trainer_name', headerName: 'Tutor Name', width: 200 },
    { field: 'mob_no', headerName: 'Tutor Mobile No', width: 150 },
    { field: 'subject_name', headerName: 'Subject', width: 150 },
    { field: 'action', headerName: 'Attendance', width: 150,
        renderCell: (params) => {
            return (
                <Button
                    variant="contained"
                    size="medium"
                    onClick={() => navigate(`/my-workspace/attendance-mark?${params.row.course_batch_id} `, { state: { batchdata: params.row } })}
                >
                    <Icon icon="wpf:view-file" />
                </Button>
            );
     },
    },
  ];

  return (
    <GlobalWrapper title={'Batch Attendance View'}>
      <Box
        sx={{
          width: '100%',
          padding: 0,
          mb: 2,
        }}
      >
        <GlobalDatagrid
          tableHead={tableHead}
          rows={batchesForAttendance?.data}
          meta={batchesForAttendance?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="sl_no"
          rowClick={false}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default BatchAttendance;
